import { getJWT } from '../Utils/Profile'
import { BASEAPI } from './constants'

const getUninvoicedMovements = async (sEstablecimiento: string) => {
    const res = await fetch(`${BASEAPI}movimientoPorFacturar`, {
        method: 'GET',
        headers: {
            Authorization: getJWT(),
        },
    })
        .then((response) => {
            return response.json()
        })
        .catch((error) => {
            console.error(error)
            return null
        })
    return res
}

const requestProforma = async (date: string, prontoPago = false) => {
    const currentUser = localStorage.getItem('currentUser')
    const user = currentUser && JSON.parse(currentUser)
    const sEstablecimiento = user?.sEstablecimiento
    return await fetch(
        `${BASEAPI}solicitudProforma?sEstablecimiento=${sEstablecimiento}&prontoPago=${prontoPago}&fecha=${date}`,
        {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: getJWT(),
            },
        }
    )
        .then((response) => {
            if (response.status === 200) {
                return response.json()
            }
            return { body: { data: 'false' } }
        })
        .catch((error) => {
            console.error(error)
            return { body: { data: 'false' } }
        })
}

const getBillingInfo = async (sEstablecimiento: string) => {
    const res = await fetch(`${BASEAPI}facturacion`, {
        method: 'GET',
        headers: {
            Authorization: getJWT(),
        },
    })
        .then((response) => {
            return response.json()
        })
        .catch((error) => {
            console.error(error)
            return null
        })
    return res
}
//FACTURACION: DETALLE DE PAGO

const getPaymentDetailInfo = async (sEstablecimiento: string) => {
    const res = await fetch(
        `${BASEAPI}datosPago?sEstablecimiento=${sEstablecimiento}`,
        {
            method: 'GET',
            headers: {
                Authorization: getJWT(),
            },
        }
    )
        .then((response) => {
            return response.json()
        })
        .catch((error) => {
            console.error(error)
            return null
        })
    return res
}
//FACTURACION:DATOS DE PAGO
const getPaymentDataInfo = async (
    sEstablecimiento: string,
    nConciliacion: string,
    nDocumento: string,
    tipoDocumento: string,
    tipoMovimiento: string
) => {
    const res = await fetch(
        `${BASEAPI}detallePagos?sEstablecimiento=${sEstablecimiento}&nConciliacion=${nConciliacion}&nDocumento=${nDocumento}&tipoDocumento=${tipoDocumento}&tipoMovimiento=${tipoMovimiento}`,
        {
            method: 'GET',
            headers: {
                Authorization: getJWT(),
            },
        }
    )
        .then((response) => {
            if (!response.ok) {
                throw new Error('Network response was not ok')
            }
            return response.json()
        })
        .catch((error) => {
            console.error(error)
            return null
        })

    return res
}
//FACTURACION:DATOS DE FACTURACION
const getBillingDetailInfo = async () => {
    const res = await fetch(`${BASEAPI}facturacion`, {
        method: 'GET',
        headers: {
            Authorization: getJWT(),
        },
    })
        .then((response) => {
            return response.json()
        })
        .catch((error) => {
            console.error(error)
            return null
        })
    return res
}
const getInvoiceData = async () => {
    return await fetch(`${BASEAPI}facturacion`, {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: getJWT(),
        },
    })
        .then((response) => {
            return response.json()
        })
        .catch((error) => {
            console.error(error)
            return null
        })
}

//FACTURACION:HISTORICO DE FACTURACION
const getBillingHistoryInfo = async () => {
    const res = await fetch(`${BASEAPI}historicoFacturacion`, {
        method: 'GET',
        headers: {
            Authorization: getJWT(),
        },
    })
        .then((response) => {
            return response.json()
        })
        .catch((error) => {
            throw new Error(error)
        })
    return res
}

const getInvoicePayData = async () => {
    const currentUser = localStorage.getItem('currentUser')
    const user = currentUser && JSON.parse(currentUser)
    const sEstablecimiento = user?.sEstablecimiento
    return await fetch(
        `${BASEAPI}datosPago?sEstablecimiento=${sEstablecimiento}`,
        {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: getJWT(),
            },
        }
    )
        .then((response) => {
            return response.json()
        })
        .catch((error) => {
            console.error(error)
            return null
        })
}

const createProformaPdf = async (
    sEstablecimiento: string,
    nConciliacion: string,
    nDocumento: string,
    tipoDocumento: string,
    tipoMovimiento: string
) => {
    try {
        const res = await fetch(
            `${BASEAPI}pdfFacturacion/generatePdfProforma?sEstablecimiento=${sEstablecimiento}&nConciliacion=${nConciliacion}&nDocumento=${nDocumento}&tipoDocumento=${tipoDocumento}&tipoMovimiento=${tipoMovimiento}`,
            {
                method: 'GET',
                headers: {
                    Accept: 'application/pdf',
                    'Content-Type': 'application/pdf',
                    Authorization: getJWT(),
                },
            }
        )

        if (!res.ok) {
            throw new Error(`Error: ${res.status}`)
        }

        const reader = res.body?.getReader()
        const chunks: Uint8Array[] = []

        if (reader) {
            let done = false

            while (!done) {
                const { done: isDone, value } = await reader.read()

                done = isDone

                if (value) {
                    chunks.push(value)
                }
            }
        }

        const pdfBlob = new Blob(chunks, { type: 'application/pdf' })
        return pdfBlob
    } catch (error) {
        console.error('Error al generar el PDF:', error)
        return null
    }
}
const getInvoiceDocument = async (properties: {
    nConciliacion?: string
    tipoMovimiento?: string
    nDocumento?: string
    tipoDocumento?: string
}) => {
    const currentUser = localStorage.getItem('currentUser')
    const user = currentUser && JSON.parse(currentUser)
    const sEstablecimiento = user?.sEstablecimiento
    return await fetch(
        `${BASEAPI}detallePagos?sEstablecimiento=${sEstablecimiento}&nConciliacion=${properties.nConciliacion}&nDocumento=${properties.nDocumento}&tipoDocumento${properties.tipoDocumento}=&tipoMovimiento=${properties.tipoMovimiento}`,
        {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: getJWT(),
            },
        }
    )
        .then((response) => {
            return response.json()
        })
        .catch((error) => {
            throw new Error(error)
        })
}

export {
    getUninvoicedMovements,
    requestProforma,
    getBillingInfo,
    getBillingHistoryInfo,
    getBillingDetailInfo,
    getPaymentDataInfo,
    getPaymentDetailInfo,
    createProformaPdf,
    getInvoiceData,
    getInvoicePayData,
    getInvoiceDocument,
}
